import { Feature } from '../../components/feature';
import Button from '../../components/Button';
import Text from '../../components/Text';

export default function DigitalMarketing() {
  return (
    <div className="relative">
      <Feature
        badge={"AI POWERED MARKETING FOR INDIAN SCHOOLS"}
        title={"Empowering India's Educators — Because the Future Deserves Better."}
        description={"Parents don't walk in first — they scroll in. SooMuch.ai makes your school visible where it matters: Google, Instagram, Facebook, and YouTube — automatically, every day."}
        imageAlt="digital markting"
        imageQuery="images/new-landing-page/digitalMarketingv2.png"
        cta={
          <>
            <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center md:mt-6 sm:mt-4 sm:gap-4">
              <Button label='Claim Your Free AI Marketing Setup' type='gradient' />
              <Button label="Book Your Live Demo" type='outlined' />
            </div>
            <span className='flex gap-2 items-center mt-4 md:flex-col md:items-center md:gap-3 sm:mt-3'>
              <button 
                disabled 
                className="py-1 px-2 bg-[#4949DE33] font-medium rounded-full md:py-1.5 md:px-3 sm:py-1 sm:px-2"
              >
                <Text 
                  type='description' 
                  label={"1% schools per state"} 
                  cName='text-sm text-[#4949DE] font-medium sm:text-xs sm:leading-5' 
                />
              </button>
              <Text 
                type='description' 
                label={"Launch ready in under 10 mins . 24x7 AI team"} 
              />
            </span>
          </>
        }
      />
      
      {/* Vertical navigation buttons - hide on mobile/tablet */}
      {/* <div className="absolute inset-y-4 -right-20 md:hidden">
        <div className="flex flex-col items-center gap-16">
          <button 
            disabled 
            className="w-fit py-1 px-2 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full" 
            style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}
          >
            <Text 
              type='description' 
              label={"why"} 
              cName='text-sm text-[#4949DE] font-medium' 
            />
          </button>
          <button 
            disabled 
            className="w-fit py-1 px-2 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full" 
            style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}
          >
            <Text 
              type='description' 
              label={"AI Team"} 
              cName='text-sm text-[#4949DE] font-medium' 
            />
          </button>
          <button 
            disabled 
            className="w-fit py-1 px-2 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full" 
            style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}
          >
            <Text 
              type='description' 
              label={"How it works"} 
              cName='text-sm text-[#4949DE] font-medium' 
            />
          </button>
          <button 
            disabled 
            className="w-fit py-1 px-2 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full" 
            style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}
          >
            <Text 
              type='description' 
              label={"Results"} 
              cName='text-sm text-[#4949DE] font-medium' 
            />
          </button>
          <button 
            disabled 
            className="w-fit py-1 px-2 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full" 
            style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}
          >
            <Text 
              type='description' 
              label={"FAQs"} 
              cName='text-sm text-[#4949DE] font-medium' 
            />
          </button>
        </div>
      </div> */}
      
      {/* Mobile/Tablet horizontal navigation - show only on smaller screens */}
      {/* <div className="hidden md:block mt-6 sm:mt-4">
        <div className="flex justify-center items-center gap-3 overflow-x-auto pb-2 px-6 md:px-4 sm:px-3 sm:gap-2">
          <button 
            disabled 
            className="flex-shrink-0 py-1.5 px-3 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full sm:py-1 sm:px-2"
          >
            <Text 
              type='description' 
              label={"why"} 
              cName='text-sm text-[#4949DE] font-medium sm:text-xs' 
            />
          </button>
          <button 
            disabled 
            className="flex-shrink-0 py-1.5 px-3 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full sm:py-1 sm:px-2"
          >
            <Text 
              type='description' 
              label={"AI Team"} 
              cName='text-sm text-[#4949DE] font-medium sm:text-xs' 
            />
          </button>
          <button 
            disabled 
            className="flex-shrink-0 py-1.5 px-3 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full sm:py-1 sm:px-2"
          >
            <Text 
              type='description' 
              label={"How it works"} 
              cName='text-sm text-[#4949DE] font-medium sm:text-xs' 
            />
          </button>
          <button 
            disabled 
            className="flex-shrink-0 py-1.5 px-3 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full sm:py-1 sm:px-2"
          >
            <Text 
              type='description' 
              label={"Results"} 
              cName='text-sm text-[#4949DE] font-medium sm:text-xs' 
            />
          </button>
          <button 
            disabled 
            className="flex-shrink-0 py-1.5 px-3 bg-[#4949DE33] border-[#4949DE] border-1 font-medium rounded-full sm:py-1 sm:px-2"
          >
            <Text 
              type='description' 
              label={"FAQs"} 
              cName='text-sm text-[#4949DE] font-medium sm:text-xs' 
            />
          </button>
        </div>
      </div> */}
    </div>
  );
}